//jshint esversion: 6
function f_validate() {

    const dbg_do_input_point_load = 0;
    const dbg_f_purge_values_to_server = 0;
    const dbg_f_all_are_zeros = 0;
    const dbg_f_extend_calculation = 0;
    const dbg_check_purge_expand = 0;
    const dbg_lf_purge_values = 0;
    const dbg_lf_expand_values = 0;

    const g_fatal_message = {
        label: [],
        values: {
            pt:
                "Neste instante estamos com dificuldades a contactar os nossos servidores. Por favor tente mais tarde.",
            en:
                "We're having trouble connecting to our servers. Please try again later.",
            es:
                "Estamos experimentando problemas al interactuar con nuestros servidores. Inténtalo de nuevo más tarde.",
            de:
                "Bei der Interaktion mit unseren Servern treten Probleme auf. Bitte versuchen Sie es noch einmal.",
            fr:
                "Nous rencontrons des problèmes lors de l'interaction avec nos serveurs. Veuillez réessayer plus tard."
        }
    };


    /////////////////////////////////////
    // Constants for Field-Validatores //
    /////////////////////////////////////
    const g_push_to_server_e = 1;
    const g_coming_from_server_e = 2;
    //const g_purge_data_e = 3;
    const g_from_skeleton_e = 4;

    const g_type_fachada = 2;

    const g_name_idx = 0;
    const g_dt_idx = 1; // l - logical, f - float, i - integer, s - string
    const g_composit_idx = 2; // s - scalar, a - array, o - object
    const g_where_idx = 3; // a - all, f - fachada, c - cobertura, g - geral
    const g_possible_values_idx = 4; // f/i - minimo e maximo - se o campo tiver 'NaN' nao
    //       procede à comparacao com esse limite
    // l   - nao precisa
    // s   - hash com os valores possiveis
    // NOT - se for vazio, nao analisa

    ///////////////////////////////
    ///// Field-Validatores ///////
    ///////////////////////////////
    const g_input_fields_a = [
        ["type", "i", "s", "a", [1, 4]],
        ["location", "i", "s", "a", [-1, 5]],

        ["direction", "i", "s", "f", [1, 2]],
        ["format", "i", "s", "f", [1, 2]],

        ["inclination", "f", "s", "c", [0, 90]],

        ["modelSpans", "f", "a", "a", [0, 20]],
        ["modelSpans-span", "f", "a", "a", [0.5, 20]],
        ["modelSpans-cant", "f", "a", "a", [0, 4]],
        ["hasCantilever", "l", "s", "a", []],
        ["transversalDistance", "f", "s", "a", [0.25, 10]],
        ["supportWidth", "i", "s", "a", [1, 3]],

        ["loads", "i", "o", "a", []],
        ["combinationFactors", "i", "o", "a", []],
        ["spanRestraints", "i", "o", "a", []]
    ];

    const g_loads_fields_a = [
        [
            "case",
            "s",
            "s",
            "a",
            { permanent: 1, live: 1, wind: 1, windLocal: 1, snow: 1, axial: 1 }
        ],
        [
            "type",
            "s",
            "s",
            "a",
            {
                accumulation: 1,
                axialRegular: 1,
                notMajored: 1,
                distributed: 1,
                distributed_min: 1,
                distributed_max: 1,
                exceptional: 1,
                point: 1,
                pressure: 1,
                regular: 1,
                suction: 1
            }
        ],
        ["value", "f", "o", "a", []]
    ];

    var g_spanRestraints_members_a = ["upperFibre", "lowerFibre"];

    var g_combinationFactors_members_a = ["live", "wind", "snow"];

    ///// FUNCTIONS //////////
    function f_is_in_range(errors, attr, val) {
        let poss_vals = attr[g_possible_values_idx];
        let error = 0;

        if (poss_vals[0] !== "NaN" && val < poss_vals[0]) error++;

        if (poss_vals[0] !== "NaN" && val > poss_vals[1]) error++;

        if (error) {
            errors.push(
                "Field '" +
                attr[g_name_idx] +
                "' is " +
                val +
                " but is not on the range [ " +
                poss_vals[0] +
                " .. " +
                poss_vals[1] +
                " ]."
            );
        }
    }

    function f_def_in_val(name, idx, obj) {
        return idx !== -1 ? obj[name][idx] : obj[name];
    }

    function if_validator(errors, attr, name, idx, obj) {
        let in_val = f_def_in_val(name, idx, obj);
        let val;
        let dts;

        if (attr[g_dt_idx] == "i") {
            dts = "an integer";
            val = parseInt(in_val);
        } else {
            dts = "a float";
            val = parseFloat(in_val);
        }

        if (val != in_val + "") {
            errors.push(
                "Field '" + name + "' has value '" + in_val + "' and is not " + dts + "."
            );
            return;
        }

        if (!(typeof in_val == "number")) {
            if (idx === -1) obj[name] = val;
            else obj[name][idx] = val;
        }

        if (attr[g_possible_values_idx].length) {
            f_is_in_range(errors, attr, val);
        }
    }

    function l_validator(errors, attr, name, idx, obj) {
        let in_val = f_def_in_val(name, idx, obj);
        let val = -1;

        if (in_val === true || in_val === false) return;

        if (typeof in_val == "string") {
            if (in_val.toLowerCase() == "true") val = true;
            else if (in_val.toLowerCase() == "false") val = false;
        }

        if (-1 === val) {
            errors.push(
                "Field '" +
                name +
                "' has value '" +
                in_val +
                "' and is not in [ true .. false ]."
            );
            return;
        }

        if (idx !== -1) obj[name] = val;
        else obj[name][idx] = val;
    }

    function s_validator(errors, attr, name, idx, obj) {
        let in_val = f_def_in_val(name, idx, obj);
        let poss_vals = attr[g_possible_values_idx];

        if (!poss_vals[in_val]) {
            errors.push(
                "Field '" +
                name +
                "' has value '" +
                in_val +
                "' and is not in " +
                JSON.stringify(Object.keys(poss_vals)).replace(/"/g, "") +
                "."
            );
            return;
        }
    }

    const f_validate_fn = {
        i: if_validator,
        f: if_validator,
        l: l_validator,
        s: s_validator
    };

    function f_validate_values(errors, attr, name, obj) {
        let composit = attr[g_composit_idx];
        let fn = f_validate_fn[attr[g_dt_idx]];

        if (composit == "s") {
            return fn(errors, attr, name, -1, obj);
        } else if (composit == "o") {
            return;
        } else if (composit == "a") {
            let i;
            let n = obj[name].length;

            for (i = 0; i < n; ++i) fn(errors, attr, name, i, obj);
        } else {
            errors.push(
                "Field '" +
                name +
                "' has composit '" +
                composit +
                "' and is not in [ s, o, a ]."
            );
        }
    }

    function f_validate_load_float(errors, in_val, loads_i, label) {
        let val = parseFloat(in_val);

        if (val != in_val + "") {
            errors.push(
                "Load " +
                loads_i.case +
                "." +
                loads_i.type +
                "." +
                label +
                " is '" +
                in_val +
                "' and is not a float."
            );
        }
    }

    function f_validate_array_floats(errors, loads_i, n_lines, n_cols) {
        let msg;
        let value = loads_i.value;
        let i, j;

        if (n_lines == 0) {
            f_validate_load_float(errors, loads_i.value, loads_i, "value");
            return;
        }

        let nn_lines = value.length;
        let m;

        if (n_lines == 1) {
            if (nn_lines != n_cols) {
                msg =
                    "Load " +
                    loads_i.case +
                    "." +
                    loads_i.type +
                    " is an array, having " +
                    nn_lines +
                    " elements but should have " +
                    n_cols +
                    ".";
                errors.push(msg);
                return;
            }

            for (i = 0; i < nn_lines; ++i) {
                f_validate_load_float(errors, value[i], loads_i, "value[ " + i + " ]");
            }
        } else {
            if (nn_lines != n_lines) {
                msg =
                    "Load " +
                    loads_i.case +
                    "." +
                    loads_i.type +
                    " is an array, having " +
                    nn_lines +
                    " lines but should have " +
                    n_lines +
                    ".";
                errors.push(msg);
                return;
            }
            for (i = 0; i < nn_lines; ++i) {
                let line_i = value[i];

                m = line_i.length;

                if (m != n_cols) {
                    msg =
                        "Load " +
                        loads_i.case +
                        "." +
                        loads_i.type +
                        " is an array, having on line " +
                        i +
                        ", " +
                        m +
                        " columns but should have " +
                        n_cols +
                        ".";
                    errors.push(msg);
                    return;
                }

                for (j = 0; j < m; ++j)
                    f_validate_load_float(
                        errors,
                        line_i[j],
                        loads_i,
                        "value[ " + i + "," + j + " ]"
                    );
            }
        }
    }

    function lf_validate(o, type, errors, validate_flds) {
        let validate_flds_n = validate_flds.length;
        let i;
        let must_exist = 0;
        let name = 0;
        let attr = 0;

        for (i = 0; i < validate_flds_n; ++i) {
            attr = validate_flds[i];
            name = attr[g_name_idx];

            must_exist = 0;

            switch (attr[g_where_idx]) {
                case "a":
                    must_exist = 1;
                    break;
                case "c":
                    if (type == 1) {
                        must_exist = 1;
                    }
                    break;
                case "f":
                    if (type == 2) {
                        must_exist = 1;
                    }
                    break;
                case "g":
                    if (type == 3) {
                        must_exist = 1;
                    }
                    break;
            }

            if (name in o) {
                f_validate_values(errors, attr, name, o);
            } else {
                if (must_exist) {
                    errors.push("Field '" + name + "' is not present.");
                }
            }
        }
    }

    function f_validate_float(errors, name, field_i, a) {
        let n = a.length;
        let i = 0;
        let val = 0;
        let a_i = 0;

        for (i = 0; i < n; ++i) {
            a_i = "" + a[i];
            val = parseFloat(a_i);

            if (val != a_i) {
                errors.push(
                    "input." +
                    name +
                    "." +
                    field_i +
                    " in position " +
                    i +
                    " has value '" +
                    a_i +
                    "' which is not a float."
                );
            }
        }
    }

    function f_validate_obj_array(errors, o, name, len, fields_a) {
        let field = o.input[name];
        let fields_n = fields_a.length;
        let i;
        let field_i;
        let e_len;

        for (i = 0; i < fields_n; ++i) {
            field_i = fields_a[i];

            if (!field[field_i]) {
                errors.push(
                    "input." + name + " does not have field '" + field_i + "'."
                );
            } else {
                e_len =
                    "combinationFactors" == name
                        ? field[field_i].value.length
                        : field[field_i].length;

                if (e_len != len) {
                    errors.push(
                        "input." +
                        name +
                        "." +
                        field_i +
                        " has length " +
                        e_len +
                        " and should have " +
                        len +
                        "."
                    );
                } else {
                    f_validate_float(errors, name, field_i, field[field_i]);
                }
            }
        }
    }

    // Used to expand internal format of a point load to
    // the expected value in data send to servers ...
    function do_input_point_load(errors, spans_n, load, the_case) {
        const l_dbg = dbg_do_input_point_load;
        let loads_i;
        let l1;
        let p1;
        let l2;
        let p2;
        let i;
        let j;
        let i_value;
        let span_a;
        let span_n;
        let span_j;
        let load_n = load.length;
        let value = [];

        if (l_dbg) {
            console.log("IN-load => the_case:", the_case);
            for (i = 0; i < load_n; ++i) console.log(i, load[i]);
        }

        for (i = 0; i < load_n; ++i) {

            loads_i = load[i];
            span_a = loads_i.span;
            span_n = span_a.length;

            // ver se todas as entradas do span estao ok
            for (j = 0; j < span_n; ++j) {
                span_j = span_a[j];

                if (parseInt(span_j) != span_j) {
                    errors.push( //OK
                        "Index of a span is '" +
                        span_j +
                        "' and is not an integer on element " +
                        i +
                        " of groups array [ " +
                        the_case +
                        ".point ]."
                    );
                }
                else if ((span_j < 1) || (span_j > spans_n)) {
                    errors.push( //OK
                        "Index of a span is " +
                        span_j +
                        " is not in [ 1.." +
                        spans_n +
                        " ] on element " +
                        i +
                        " of groups array [ " +
                        the_case +
                        ".point ]."
                    );
                }
            }

            i_value = loads_i.value;
            p1 = i_value[0];
            l1 = i_value[1];
            p2 = i_value[2];
            l2 = i_value[3];

            // garantir que 11 e l2 sao floats a variar entre 0 e 100
            if (l1 < 0 || l1 > 100) {
                errors.push( //OK
                    "l1 is " + l1 +
                    " and is not in [0..100] " +
                    "on element " +
                    i +
                    " of groups array [ " +
                    the_case +
                    ".point ]."
                );
            }
            else if (l2 < 0 || l2 > 100) {
                errors.push( //OK
                    "l2 is " + l2 +
                    " and is not in [0..100] " +
                    "on element " +
                    i +
                    " of groups array [ " +
                    the_case +
                    ".point ]."
                );
            }

            // garantir que p1 e p2 sao floats entre -100 e +100
            if (p1 < -100 || p1 > 100) {
                errors.push( //OK
                    "p1 is " + p1 +
                    " and is not in [-100..100] " +
                    "on element " +
                    i +
                    " of groups array [ " +
                    the_case +
                    ".point ]."
                );
            }
            else if (p2 < -100 || p2 > 100) {
                errors.push( //OK
                    "p2 is " + l2 +
                    " and is not in [-100..100] " +
                    "on element " +
                    i +
                    " of groups array [ " +
                    the_case +
                    ".point ]."
                );
            }

            if (p1 || p2) {
                value.push({
                    "p1": p1,
                    "l1": l1,
                    "p2": p2,
                    "l2": l2,
                    "span": span_a
                });
            }
        }

        if (l_dbg) {
            console.log("OUT-load:");
            let value_n = value.length;
            if (value_n) {
                for (i = 0; i < value_n; ++i) console.log(i, value[i]);
                console.log("\n");
            }
            else {
                console.log("No data mapped out ...\n");
            }
        }

        return value;
    }

    // map from internal.loads to input loads ...
    function f_map_to_server_bot(errors, calculation) {
        //console.log( "DBG-f_map_to_server_bot:", J_str( calculation ) )

        const input = calculation.input;
        const internal = input.internal;
        const spans_n = input.modelSpans.length;

        // confirmar apenas que os points estao OK
        const i_points = internal.loads.points;
        const ip_permanent = i_points.permanent;
        const ip_live = i_points.live;

        // find point live
        const loads_a = input.loads;
        const load_n = loads_a.length;
        let loads_i;
        let found_permanent_point = 0;
        let found_live_point = 0;
        let value;

        for (let i = load_n - 1; i > -1; --i) {
            loads_i = loads_a[i];
            let do_delete = 0;

            if (loads_i.case == "live" && loads_i.type == "point") {
                found_live_point = 1;
                value = do_input_point_load(errors, spans_n, ip_live, "live");
                if (value.length) {
                    loads_i.value = do_input_point_load(errors, spans_n, ip_live, "live");
                }
                else {
                    do_delete = 1;
                }
            } else if (loads_i.case == "permanent" && loads_i.type == "point") {
                found_permanent_point = 1;
                value = do_input_point_load(errors, spans_n, ip_permanent, "permanent");
                if (value.length) {
                    loads_i.value = value;
                }
                else {
                    do_delete = 1;
                }
            }

            if (do_delete) {
                input.loads.splice(i, 1);
            }
        }

        // se nao existia entrada "permanent" && "point"
        if (0 == found_permanent_point) {
            value = do_input_point_load(errors, spans_n, ip_permanent, "permanent");
            if (value.length) {
                loads_a.push({
                    "case": "permanent",
                    "type": "point",
                    "value": value
                });
            }
        }

        // se nao existia entrada "live" && "point"
        if (0 == found_live_point) {
            value = do_input_point_load(errors, spans_n, ip_live, "live");
            if (value.length) {
                loads_a.push({
                    "case": "live",
                    "type": "point",
                    "value": value
                });
            }
        }
    }

    // REMOVE oq ue nao é necessario enviar para o servidor ...
    function f_purge_values_to_server(calcData, internal, calculation) {
        const l_dbg = dbg_f_purge_values_to_server;
        //if( l_dbg ) console.log( "DBG-f_purge_values_to_server:", internal );

        const input = calculation.input;
        const spans_n = input.modelSpans.length;
        const type = input.type;

        // find point live
        const loads_a = input.loads;
        let loads_n = loads_a.length;
        let loads_i;
        let remove = 0;
        let perm_dist_a = [];

        if (l_dbg) console.log("INFO-f_purge_values_to_server: removing non used fields.");

        for (let i = loads_n - 1; i > -1; --i) {

            remove = 0;

            loads_i = loads_a[i];

            //if( l_dbg ) console.log( "DBG-f_purge_values_to_server:", i, loads_i );

            if (
                type == g_type_fachada &&
                (loads_i.case == "live" || loads_i.case == "snow")
            ) {
                if (l_dbg) console.log("REMOVING load", i, input.loads[i]);
                remove = 1;

            } else if (
                loads_i.case == "snow" &&
                loads_i.type == "accumulation" &&
                false == internal.loads.snowAccumulation
            ) {
                if (l_dbg) {
                    console.log(
                        "REMOVING load ( internal.loads.snowAccumulation == false ) => ",
                        i,
                        input.loads[i]
                    );
                }
                remove = 1;

            } else if (
                loads_i.case == "snow" &&
                loads_i.type == "exceptional" &&
                false == internal.loads.snowExceptional
            ) {
                if (l_dbg) {
                    console.log(
                        "REMOVING load ( internal.loads.snowExceptional == false ) => ",
                        i,
                        input.loads[i]
                    );
                }
                remove = 1;

            } else if (
                loads_i.case == "windLocal" &&
                false == internal.loads.windLocal
            ) {
                if (l_dbg) {
                    console.log(
                        "REMOVING load ( internal.loads.windLocal == false ) => ",
                        i,
                        input.loads[i]
                    );
                }
                remove = 1;

            } else if (loads_i.case == "axial") {
                if (false == internal.axial) {
                    if (l_dbg) {
                        console.log(
                            "REMOVING load ( internal.axial == false ) => ",
                            i,
                            input.loads[i]
                        );
                    }
                    remove = 1;
                }
                else {
                    // add signal to value - returning to initial code.
                    if (0 && ('axial' in internal.loads)) {
                        loads_i.value = (internal.loads.axial.direction == 1 ? internal.loads.axial.value : -internal.loads.axial.value);
                    }
                }
            }

            // apagar os live distributed se vazios
            else if (
                loads_i.case == "live" &&
                loads_i.type == "distributed" &&
                f_all_are_zeros(1, spans_n, loads_i.value)
            ) {
                if (l_dbg) {
                    console.log(
                        "REMOVING load.live.distributed because all ZEROS => ",
                        i,
                        input.loads[i]
                    );
                }
                remove = 1;
            }

            else if (
                loads_i.case == "permanent" &&
                loads_i.type.substr(0, 11) == "distributed"
            ) {
                if (f_all_are_zeros(1, spans_n, loads_i.value)) {
                    if (l_dbg) {
                        console.log(
                            "REMOVING load.permanent." + loads_i.type + " because all ZEROS => ",
                            i,
                            input.loads[i]
                        );
                    }
                    remove = 1;
                }
                else {
                    if ('limit' in input.loads[i]) {
                        input.loads[i].type = input.loads[i].type + "_" + input.loads[i].limit;
                        delete input.loads[i].limit;
                        delete input.loads[i].dt;
                        perm_dist_a.push(input.loads[i]);
                    }
                }
            }

            if (remove) {
                input.loads.splice(i, 1);
            }
            else {
                delete input.loads[i].dt;
            }
        }

        // agora vamos apagar as entradas
        if ((perm_dist_a.length == 1) && (perm_dist_a[0].type != "distributed")) {
            perm_dist_a[0].type = "distributed";
        }

        purgValues(calcData, calculation);

        if (false == internal.spanRestraints) {
            if (l_dbg) {
                console.log(
                    "REMOVING spanRestraints ( internal.spanRestraints.axial == false )"
                );
            }
            delete input.spanRestraints;
        }
    }

    function f_build_array(lines, cols) {
        let obj = [];
        let i = [];
        let j = [];

        if ((lines == 1) && (cols == 1)) {
            obj = 0;
        }
        else if (lines == 1) {
            obj = new Array(cols);
            for (j = 0; j < cols; ++j) {
                obj[j] = 0;
            }
        }
        else {
            obj = new Array(lines);
            for (i = 0; i < lines; ++i) {
                let obj_i = obj[i] = new Array(cols);
                for (j = 0; j < cols; ++j) {
                    obj_i[j] = 0;
                }
            }
        }
        return obj;
    }

    function f_all_are_zeros(lines, cols, values) {
        const l_dbg = dbg_f_all_are_zeros;
        if (l_dbg) console.log("DBG-all_are_zeros:", lines, cols, values);

        let i = 0;
        let all_are_zeros = 1;

        if (lines == 1) {

            if (cols == 1) {
                if (values != 0) {
                    all_are_zeros = 0;
                }
            }
            else {
                for (i = 0; i < cols; ++i) {
                    if (values[i] != 0) {
                        all_are_zeros = 0;
                        break;
                    }
                }
            }
        } else {
            let j = 0;
            let line_i = [];

            for (i = 0; i < lines; ++i) {
                line_i = values[i];

                for (j = 0; j < cols; ++j) {
                    if (line_i[j] != 0) {
                        all_are_zeros = 0;
                        break;
                    }
                }

                if (0 == all_are_zeros) {
                    break;
                }
            }
        }

        if (l_dbg) console.log("DBG-all_are_zeros =>all_are_zeros", all_are_zeros);
        return all_are_zeros;
    }

    // to add eventual delete entries ...
    function f_extend_calculation(error, skeleton, constants, calculation) {
        const l_dbg = dbg_f_extend_calculation;

        //console.log( ">>>>> skeleton:", skeleton );
        //console.log( ">>>>> constants:", constants );
        //console.log( ">>>>> calculation:", calculation );
        //console.log( ">>>>> calculation.modelSpans:", calculation.input.modelSpans );

        const skl_loads_a = skeleton.input.loads;
        const skl_loads_n = skl_loads_a.length;

        const input = calculation.input;
        const spans_n = input.modelSpans.length;
        const type = input.type;

        const internal = input.internal;

        // find point live
        const loads_a = input.loads;
        const loads_n = loads_a.length;

        const errors = [];

        let loads_i;

        const hasCantilever = input.hasCantilever;

        const case_type_h = {};

        let skl_load_i;

        for (let i = 0; i < loads_n; ++i) {
            loads_i = loads_a[i];
            case_type_h[loads_i.case + "." + loads_i.type] = 1;
        }

        if (l_dbg) {
            console.log("INFO-f_extend_calculation: added non existing fields.");
        }

        if (hasCantilever && spans_n < 3) {
            errors.push(
                "Can not extend data because ( spans_n < 3 ) and hasCantilever is true."
            );
            return; // just return ...
        }

        // NOTA: no caso dos points nao precisa adicionar porque o
        //       trabalho é feito no internal ...
        function lf_add_live_distributed_if_null() {
            if (case_type_h["live.distributed"])
                // if we have live distributed ... just return
                return;

            // if here ... need to push live.distributed load
            let i;
            let value = new Array(spans_n);

            for (i = 0; i < spans_n; ++i) {
                value[i] = 0;
            }

            // push live.distributed ...
            input.loads.push({
                case: "live",
                type: "distributed",
                value: value
            });
        }

        function lf_find_and_push_default_loads(key) {
            let i;
            let found;
            let has_type = "type" in key;

            for (i = 0; i < skl_loads_n; ++i) {
                found = 0;

                skl_load_i = skl_loads_a[i];

                if (has_type) {
                    if (key.case == skl_load_i.case && key.type == skl_load_i.type) {
                        found = 1;
                    }
                } else {
                    if (key.case == skl_load_i.case) {
                        found = 1;
                    }
                }

                if (found) {
                    // se ja esta no vector dos loads ... continua ... (caso do skeleton ... que pode ter ja entradas )
                    if (case_type_h[skl_load_i.case + "." + skl_load_i.type]) continue;

                    // FATAL --- NAO ALTERAR A ORDEM //////////
                    // se for de dimensao fixa ...                     //REF-dim-fix
                    if (
                        (skl_load_i.case == "snow" && skl_load_i.type == "accumulation") || // internal.loads.snowAccumulation
                        skl_load_i.case == "windLocal" || // internal.loads.windLocal
                        skl_load_i.case == "axial" //
                    ) {
                        loads_a.push(skl_load_i);
                    } else if (
                        skl_load_i.case == "snow" || // REF-dynamic-vector
                        (skl_load_i.case == "live" && skl_load_i.type == "distributed")
                    ) {
                        loads_a.push(lf_do_vector());
                    }
                }
            }
        }

        function lf_do_vector() {
            let i = 0;

            let value = skl_load_i.value;
            let value_out = [];
            let l_spans_n = spans_n;

            if (hasCantilever) {
                value_out.push(value[0]);

                l_spans_n -= 1;

                for (i = 1; i < l_spans_n; ++i) value_out.push(value[1]);

                value_out.push(value[value.length - 1]);
            } else {
                for (i = 0; i < l_spans_n; ++i) value_out.push(value[1]);
            }

            let load_out = {
                case: skl_load_i.case,
                type: skl_load_i.type,
                value: value_out
            };

            return load_out;
        }

        // temos que adicionar os defaults assoociados a live e snow ...
        if (type == g_type_fachada) {
            if (l_dbg) console.log("Add live and snow default loads.");

            // CRITICO: o caso do "live" && "point" esta dentro do internal pelo que nao precisa ser extended ...
            lf_find_and_push_default_loads({ case: "live", type: "distributed" }); // solved in REF-dynamic-vector
            lf_find_and_push_default_loads({ case: "snow" }); // solved in REF-dynamic-vector
        }

        if (false == internal.loads.snowAccumulation && type != g_type_fachada) {
            // solved in REF-dim-fix
            if (l_dbg) console.log("Add snowAccumulation default loads.");
            lf_find_and_push_default_loads({ case: "snow", type: "accumulation" });
        }

        if (false == internal.loads.snowExceptional && type != g_type_fachada) {
            // solved in REF-dim-fix
            if (l_dbg) console.log("Add snowExceptional default loads.");
            lf_find_and_push_default_loads({ case: "snow", type: "exceptional" });
        }

        if (false == internal.loads.windLocal) {
            // solved in REF-dim-fix
            if (l_dbg) console.log("Add windLocal default loads.");
            lf_find_and_push_default_loads({ case: "windLocal" });
        }

        if (false == internal.axial) {
            // solved in REF-dim-fix
            if (l_dbg) console.log("Add axial default loads.");
            lf_find_and_push_default_loads({ case: "axial" });
        }

        if (false == internal.spanRestraints) {
            // REF-spanRestraints
            if (l_dbg) console.log("Add default spanRestraints.");

            const upperFibre = [];
            const default_upp = constants.spanRestraintsDefaults[type].upperFibre;
            const lowerFibre = [];
            const default_low = constants.spanRestraintsDefaults[type].lowerFibre;

            let l_spans_n = input.hasCantilever ? spans_n - 2 : spans_n;

            for (let i = 0; i < l_spans_n; ++i) {
                upperFibre.push(default_upp);
                lowerFibre.push(default_low);
            }

            input.spanRestraints = {
                upperFibre: upperFibre,
                lowerFibre: lowerFibre
            };
        }

        // agora acrescenta os live.distributed se nao chegam do servidor/skwleton
        lf_add_live_distributed_if_null();
    }

    /////////////
    // in cb ( err, obj_to_be_processed )
    //          [ e1, e2, ..., eN ] - array de strings com os erros que aconteceram
    function validate_from_to_server(cust, calcData, calculation, direction, cb) {
        let errors = [];
        let input = calculation.input;
        let type = input.type;
        let spans_a = input.modelSpans;
        let spans_n = spans_a.length;
        let l_spans_n = input.hasCantilever ? spans_n - 2 : spans_n;
        let t_length = 0.0;
        let i = 0;

        //console.log( J_str( input.spanRestraints ) );
        //console.log( "type:", type, J_str( input.internal.spanRestraints[ type ] ) );

        for (i = 0; i < spans_n; ++i) t_length += spans_a[i];

        t_length = t_length.toFixed(2);

        if (input.hasCantilever) {
            input["modelSpans-cant"] = [spans_a[0], spans_a[spans_n - 1]];
            input["modelSpans-span"] = [];
            for (i = 1; i < spans_n - 1; ++i)
                input["modelSpans-span"].push(spans_a[i]);
        } else {
            input["modelSpans-cant"] = [0];
            input["modelSpans-span"] = spans_a;
        }

        lf_validate(input, type, errors, g_input_fields_a);
        delete input["modelSpans-cant"];
        delete input["modelSpans-span"];

        // validar loads ...
        let loads_a = input.loads;
        let loads_n = loads_a.length;
        let loads_i;

        if (direction == g_coming_from_server_e) {
            for (i = loads_n - 1; i > -1; --i) {
                loads_i = loads_a[i];
                if ((loads_i.case == "permanent") && (loads_i.type == "distributed")) {
                    loads_i.type = "distributed_min";
                }
            }
        }

        for (i = loads_n - 1; i > -1; --i) {
            loads_i = loads_a[i];

            if (direction == g_from_skeleton_e) {
                delete loads_i.dt;
            }

            lf_validate(loads_i, type, errors, g_loads_fields_a);

            // de acordo com o tipo teremos que ver a maneira como validamos os values
            if (
                (loads_i.case == "axial" && loads_i.type == "axialRegular") ||
                (loads_i.case == "axial" && loads_i.type == "axialNotMajored")
            ) {
                f_validate_array_floats(errors, loads_i, 0);
            } else if (
                (loads_i.case == "wind") ||
                (loads_i.case == "windLocal") ||
                (loads_i.case == "snow" && loads_i.type == "accumulation")
            ) {
                f_validate_array_floats(errors, loads_i, 3, 2);

                let values = loads_i.value;
                let l_total = values[0][1] + values[1][1] + values[2][1];
                let l_total_s = l_total.toFixed(2);

                if (l_total && (t_length != l_total_s)) {
                    errors.push(
                        "Expected sum of LiS is " +
                        t_length +
                        " and total length of strucuture is " +
                        l_total_s +
                        " [ " +
                        loads_i.case +
                        "." +
                        loads_i.type +
                        " ]."
                    );
                }
            } else if (
                (loads_i.case == "permanent" && loads_i.type == "distributed") ||
                (loads_i.case == "permanent" && loads_i.type == "distributed_min") ||
                (loads_i.case == "permanent" && loads_i.type == "distributed_max") ||
                (loads_i.case == "live" && loads_i.type == "distributed") ||
                (loads_i.case == "snow" && loads_i.type == "regular") ||
                (loads_i.case == "snow" && loads_i.type == "exceptional")
            ) {
                f_validate_array_floats(errors, loads_i, 1, spans_n);

                if ((direction == g_from_skeleton_e) && (loads_i.case == "permanent")) {
                    if (loads_i.type == "distributed_min") {
                        loads_i.type = "distributed";
                        loads_i.limit = "min";
                    }
                    else if (loads_i.type == "distributed_max") {
                        loads_i.type = "distributed";
                        loads_i.limit = "max";
                    }
                    else if (loads_i.type == "distributed") {
                        loads_i.limit = "min";
                        let value = [];
                        for (let j = 0; j < spans_n; ++j) {
                            value[j] = 0;
                        }
                        input.loads.push({ "case": "permanent", type: "distributed", value: value, limit: 'max' });
                    }
                }

            } else if (
                (loads_i.case == "live" && loads_i.type == "point") ||
                (loads_i.case == "permanent" && loads_i.type == "point")
            ) {
                //console.log( "\n\nIS POINT:", J_str( loads_i ) );
                // NO need to validate ... because the validation is done
                // inside internal ... and the MAP to input is formaly done by
                // do_input_point_load function ...
            }
        }

        // validar spanRestraints & combinationFactors
        if ("spanRestraints" in input) {
            f_validate_obj_array(
                errors,
                calculation,
                "spanRestraints",
                l_spans_n,
                g_spanRestraints_members_a
            );
        }

        if ("combinationFactors" in input)
            f_validate_obj_array(
                errors,
                calculation,
                "combinationFactors",
                3,
                g_combinationFactors_members_a
            );

        // se empurra para o servidor apago o que esta a mais ...
        if (g_push_to_server_e == direction) {
            f_purge_values_to_server(calcData, input.internal, calculation); // also purgeValues ...
        }
        else if (g_coming_from_server_e == direction) {
            expandValues(calcData, calculation);
        }

        var resp;

        if (errors.length) {
            switch (direction) {
                case g_push_to_server_e:
                    resp = lf_build_fatal_error("FCST03", cust, calculation, errors);
                    break;
                case g_coming_from_server_e:
                    resp = lf_build_fatal_error("FCST04", cust, calculation, errors);
                    break;
                case g_from_skeleton_e:
                    resp = lf_build_fatal_error("FCST05", cust, calculation, errors);
                    break;
            }

            cb(resp.message, resp.to_server);
        } else {
            if (direction == g_push_to_server_e) {
                cb(null, {
                    success: true,
                    data: calculation
                });
            } else {
                cb(null, calculation);
            }
        }
    }


    function fromServer(cust, calcData, _calculation, _cb) {

        let calculation = null;
        let cb = null;
        let direction;
        let errors = [];
        let skeleton = calcData.skeleton;
        let constants = calcData.constants;

        if (arguments.length == 4) {
            calculation = JSON.parse(JSON.stringify(_calculation));
            cb = _cb;
            direction = g_coming_from_server_e;
            f_extend_calculation(errors, skeleton, constants, calculation);

            if (errors.length) {
                let resp = lf_build_fatal_error("FCST04", cust, calculation, errors);
                return cb(resp.message, resp.to_server);
            }
        } else {
            cb = _calculation;
            direction = g_from_skeleton_e;
            calculation = JSON.parse(JSON.stringify(skeleton));
        }

        delete calculation.id;

        validate_from_to_server(cust, calcData, calculation, direction, cb);
    }

    function toServer(cust, calcData, _calculation, cb) {

        let errors = [];

        //clone calculation 
        let calculation = JSON.parse(JSON.stringify(_calculation));

        f_map_to_server_bot(errors, calculation);

        if (errors.length) {
            let resp = lf_build_fatal_error("FCST03", cust, calculation, errors);
            return cb(resp.message, resp.to_server);
        }

        validate_from_to_server(cust, calcData, calculation, g_push_to_server_e, cb);
    }

    function lf_build_fatal_error(code, cust, _calculation, errors) {
        return {
            message: g_fatal_message.values[cust.lang],
            to_server: {
                success: false,
                code: code,
                errors: errors,
                data: _calculation
            }
        };
    }

    // check = 1
    // purge = 2
    // expand = 3
    function check_purge_expand(calcData, calculation, expnd_purg_chck) {
        const l_dbg = dbg_check_purge_expand;
        const spans_n = calculation.input.modelSpans.length;

        let ref_a = calcData.skeleton.input.loads;
        let ref_n = ref_a.length;

        let loads_a = calculation.input.loads;
        let loads_n = loads_a.length;
        let int_loads = calculation.input.internal.loads.points;

        let ref_i;
        let ref_o;
        let i_load;
        let dt_o;

        if (expnd_purg_chck == 1) {
            return lf_chck_has_values();
        }
        else if (expnd_purg_chck == 2) {
            return lf_purge_values();
        }
        else if (expnd_purg_chck == 3) {
            return lf_expand_values();
        }
        return;

        function lf_chck_has_values() {
            let has_values = 0;
            for (ref_i = 0; ref_i < ref_n; ++ref_i) {
                ref_o = ref_a[ref_i];
                dt_o = ref_o.dt;

                i_load = lf_get_load(ref_o);

                if (-1 !== i_load) {
                    let has_val = lf_has_values(i_load, dt_o);
                    if (l_dbg && has_val) {
                        console.log("HasValue:", i_load);
                    }
                    has_values += has_val;
                }
            }

            return (has_values ? true : false);
        }

        function lf_purge_values() {
            const l_dbg = dbg_lf_purge_values;
            let has_values = 0;
            let idx = 0;

            if (l_dbg) {
                console.log("\n--------- lf_purge_values ---------");
                console.log("'chosenSolution' in calculation?", ('chosenSolution' in calculation));
                console.log("     'pdfReport' in calculation?", ('pdfReport' in calculation));
                console.log("     'appUserId' in calculation?", ('appUserId' in calculation));
                console.log("        'output' in calculation?", ('output' in calculation));

                if (l_dbg > 1) {
                    console.log("--------- loads_a ---------");
                    for (let i = 0; i < loads_n; ++i) {
                        let i_load = loads_a[i];
                        console.log("loads_a[", i, "] =>", i_load.case, i_load.type);
                    }
                    console.log("---------\n");
                }
            }

            delete calculation.chosenSolution;
            delete calculation.pdfReport;
            delete calculation.appUserId;
            delete calculation.output;

            for (ref_i = 0; ref_i < ref_n; ++ref_i) {
                ref_o = ref_a[ref_i];
                dt_o = ref_o.dt;
                idx = lf_get_load_idx(ref_o);

                if (l_dbg) {
                    console.log(" ref[", (ref_i < 10 ? " " + ref_i : ref_i),
                        "]                          ", ref_o.case, ref_o.type);
                }

                if (-1 !== idx) {
                    i_load = loads_a[idx];

                    if (!lf_has_values(i_load, dt_o)) {
                        loads_a.splice(idx, 1);
                        if (l_dbg) {
                            console.log("load[", (idx < 10 ? " " + idx : idx),
                                "] is empty ... removing it.", i_load.case, i_load.type);
                        }
                    }
                    else {
                        if (l_dbg) {
                            console.log("load[", idx, "] hasValue:", i_load);
                        }
                        has_values++;
                    }
                }
            }

            if (l_dbg) {
                console.log("After lf_purge_values ... loads_a.length:", loads_a.length);
                console.log(loads_a);
            }

            return has_values;
        }

        function lf_expand_values() {
            const l_dbg = dbg_lf_expand_values;
            let has_values = 0;
            let add_values = 0;
            let idx = 0;

            if (l_dbg) {
                console.log("\n--------- loads_a before expand: ---------");
                for (let i = 0; i < loads_n; ++i) {
                    let i_load = loads_a[i];
                    console.log("loads_a[", (i < 10 ? " " + i : i), "] =>", i_load.case, i_load.type);
                }
                console.log("---------\n");
            }

            for (ref_i = 0; ref_i < ref_n; ++ref_i) {
                ref_o = ref_a[ref_i];
                dt_o = ref_o.dt;
                idx = lf_get_load_idx(ref_o);

                if (l_dbg) {
                    console.log("ref[", (ref_i < 10 ? " " + ref_i : ref_i),
                        "] =>", ref_o.case, ref_o.type);
                }

                if (-1 === idx) { // ... quer dizer que nao existe ...
                    if (l_dbg) {
                        console.log("             need to build ...");
                    }
                    let builded_obj = lf_build_values(ref_o, dt_o);

                    if ((ref_o.case == 'permanent') && (ref_o.type.substr(0, 11) == 'distributed')) {
                        builded_obj.limit = ref_o.type.substr(12);
                        builded_obj.type = 'distributed';
                    }
                    loads_a.push(builded_obj);
                    add_values++;
                }
                else {
                    if (l_dbg) {
                        console.log("load[", idx, "] hasValue:", loads_a[idx]);
                    }
                    if ((ref_o.case == 'permanent') && (ref_o.type.substr(0, 11) == 'distributed')) {
                        loads_a[idx].limit = ref_o.type.substr(12);
                        loads_a[idx].type = 'distributed';
                    }
                    has_values++;
                }
            }

            if (l_dbg) {
                console.log("\n--------- loads_a after expand: ---------");
                loads_n = loads_a.length;
                for (let i = 0; i < loads_n; ++i) {
                    let i_load = loads_a[i];
                    if ('limit' in i_load) {
                        console.log("loads_a[", (i < 10 ? " " + i : i), "] =>", i_load.case, i_load.type, i_load.limit, i_load.value);
                    }
                    else {
                        console.log("loads_a[", (i < 10 ? " " + i : i), "] =>", i_load.case, i_load.type, i_load.value);
                    }
                }
                console.log("---------\n");
            }

            return { has_values, add_values };
        }

        function lf_build_values(ref_o, dt_o) {
            let lines = dt_o[0];
            let cols = (dt_o[1] == 'n' ? spans_n : dt_o[1]);
            let obj = {
                "case": ref_o.case,
                "type": ref_o.type,
                "value": []
            };

            if (cols !== 'p') {
                obj.value = f_build_array(lines, cols);
            }

            return obj;
        }

        function lf_has_values(i_load, dt_o) {
            let lines = dt_o[0];
            let cols = (dt_o[1] == 'n' ? spans_n : dt_o[1]);

            if (cols === 'p') {
                return (f_point_load_is_zero(int_loads[i_load.case]) ? 0 : 1);
            }
            else {
                return (f_all_are_zeros(lines, cols, i_load.value) ? 0 : 1);
            }
        }

        function f_point_load_is_zero(pt_a) {
            let pt_n = pt_a.length;
            let is_zero = 1;

            for (let i = 0; i < pt_n; ++i) {
                let pt_i = pt_a[i];
                let value = pt_i.value;
                let span = pt_i.span;
                if (span.length != 0) {
                    // ver se esta definida alguma carga ...
                    if ((value[0] != 0) || (value[2] != 0)) {
                        is_zero = 0;
                        break;
                    }
                }
            }
            return is_zero;
        }

        // encontra a carga
        function lf_get_load_idx(ref_o) {
            let case_o = ref_o.case;
            let type_o = ref_o.type;
            loads_n = loads_a.length;

            for (let i = 0; i < loads_n; ++i) {
                let i_load = loads_a[i];
                if ((case_o == i_load.case) && (type_o == i_load.type)) {
                    return i;
                }
            }
            return -1;
        }

        function lf_get_load(ref_o) {
            let case_o = ref_o.case;
            let type_o = ref_o.type;
            let limit = 0;
            loads_n = loads_a.length;

            if (type_o.substr(0, 12) == "distributed_") {
                limit = type_o.substr(12);
                type_o = "distributed";
            }
            for (let i = 0; i < loads_n; ++i) {
                let i_load = loads_a[i];

                if ((case_o == i_load.case) && (type_o == i_load.type)) {
                    if (limit !== 0) {
                        if (limit === i_load.limit) {
                            return i_load;
                        }
                    }
                    else {
                        return i_load;
                    }
                }
            }
            return -1;
        }
    }

    function purgValues(calcData, calculation) {
        //console.log( "\npurgValues ..." );
        return check_purge_expand(calcData, calculation, 2);
    }

    function expandValues(calcData, calculation) {
        //console.log( "\nexpandValues ..." );
        return check_purge_expand(calcData, calculation, 3);
    }

    function hasValues(calcData, calculation) {
        //console.log( "\nhasValues ..." );
        return check_purge_expand(calcData, calculation, 1);
    }

    return {
        toServer,
        fromServer,
        hasValues,
        purgValues,
        expandValues
    };
}

const { toServer, fromServer, hasValues } = f_validate();

export default {
    toServer,
    fromServer,
    hasValues
};
